import React from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-core';
import { Avatar, AvatarSize } from '@amzn/stencil-react-components/avatar';
import { EmployeePopoverCard } from './EmployeePopoverCard';
import { useEmployeeByAlias } from '../../hooks/useEmployeeByAlias';

interface LeaderCellProps {
  alias: string;
}

/**
 * Inline leader cell: avatar with the Stencil-rendered clickable `@alias`
 * label plus the full name in bold default body color (matches the Organizer
 * field pattern in MeetingFormContainer). Falls back to muted raw alias when
 * the employee record cannot be resolved (former employees, PAPI errors).
 */
export const LeaderCell: React.FC<LeaderCellProps> = ({ alias }) => {
  const employee = useEmployeeByAlias(alias);
  const displayName = employee?.displayName || employee?.employee_name;

  return (
    <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
      <EmployeePopoverCard loginName={alias} renderWithPortal>
        <Avatar username={alias} size={AvatarSize.ExtraSmall} imageAltText={`Profile image of ${alias}`} />
      </EmployeePopoverCard>
      {displayName ? (
        <Box fontSize="body-s" fontWeight="bold">
          {displayName}
        </Box>
      ) : (
        <Box fontSize="body-s" color="text-body-secondary">
          {alias}
        </Box>
      )}
    </SpaceBetween>
  );
};
